import { Button, type ButtonProps } from "@mui/material";

export default function CloseButton({ children, ...props }: ButtonProps) {
  return (
    <Button type="reset" variant="text" color="inherit" {...props}>
      {children ?? "Schließen"}
    </Button>
  );
}
